import isNil from 'lodash/isNil';
import { IVGSUpdateEventData } from 'obt-common';

export function getVGSError(error: any): IVGSUpdateEventData | null {
  if (
    typeof error === 'object' &&
    'errorMessages' in error &&
    error.errorMessages.length > 0 &&
    error.errors &&
    error.errors.length > 0 &&
    error.name &&
    !isNil(error.isValid)
  ) {
    return error as IVGSUpdateEventData;
  }

  return null;
}
